export class Clients {
  static SHINE_RESUNGA = 'Shine Resunga Development Bank';
  static EVEREST = 'Everest Bank Limited';
  static ICFC = 'ICFC Finance Limited';
  static Bank = 'BANK';
  static NEPAL_BANK_LIMITED = 'Nepal Bank Limited';
  static MBANK_PLUS = 'mBank Technology Private Limited';

}
